export default {"src":"/_next/static/media/service-default-light.bd6ebd9f.svg","height":90,"width":90,"blurWidth":0,"blurHeight":0};